import errorCodes from "../const/errorCodes";
var getOtpErrorMessage = function (otpErrorCode) {
    switch (otpErrorCode) {
        case errorCodes.invalidScope:
            return "forms.errors.page.invalidScope";
        case errorCodes.userDeclined:
            return "forms.errors.page.userDeclined";
        case errorCodes.accessDenied:
            return "forms.errors.page.accessDenied";
        case errorCodes.serverError:
            return "forms.errors.page.serverError";
        default:
            return "".concat(errorCodes.unhandledError, " ").concat(otpErrorCode);
    }
};
export default getOtpErrorMessage;
